export default __webpack_public_path__ + "static/media/me-icon.a2cbff63.webp";